"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberFormatSpace = void 0;
const numberFormatMoney_1 = require("./numberFormatMoney");
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param forcezeros czy zachować zera ,00
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function numberFormatSpace(value, forcezeros, precision = 2) {
    let ext;
    if (typeof value !== 'string') {
        ext = (0, numberFormatMoney_1.numberFormatMoney)(value, forcezeros, precision);
    }
    else {
        ext = value;
    }
    const parts = ext.split(',');
    let result = '';
    const partsLength = parts[0].length - 1;
    for (let i = 0; i <= partsLength; i++) {
        result = parts[0][partsLength - i] + result;
        if (i < partsLength && (i === 2 || i === 5 || i === 8 || i === 11)) {
            result = ' ' + result;
        }
    }
    if (parts.length > 1) {
        return result + ',' + parts[1];
    }
    else {
        return result;
    }
}
exports.numberFormatSpace = numberFormatSpace;
//# sourceMappingURL=numberFormatSpace.js.map